import { Leaf } from "lucide-react";

const ITEMS = [
  "Cosmesi Biologica Certificata",
  "Epilazione Laser Progressiva",
  "Massaggi Olistici",
  "Massaggi Corpo e Viso",
  "Filo Orientale",
  "Manicure & Pedicure Spa",
  "Protocolli Viso su Misura",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-gold/30 bg-sage py-5 text-cream" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex w-max animate-marquee items-center gap-10 will-change-transform">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap font-serif text-2xl italic tracking-wide md:text-3xl">
            {t}
            <Leaf className="h-4 w-4 text-gold-light" />
          </span>
        ))}
      </div>
    </div>
  );
};
